import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

const MIGRATED_VERSION:DesignerVersion = 18;

export const migration_17_18:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.spreadsheets && designState.spreadsheets.workbooks )
        {
            Object.values(designState.spreadsheets.workbooks).forEach((workbook:any) =>
            {
                if( !workbook.view.cellSettings )
                {
                    workbook.view.cellSettings = {};

                    if( !workbook.view.sheetSettings )
                        workbook.view.sheetSettings = {};

                    workbook.runtime.sheets.forEach(sheet => {
                        if (!workbook.view.sheetSettings[sheet.id])
                        {
                            workbook.view.sheetSettings[sheet.id] = {
                                id: sheet.id,
                                sheetId: sheet.id,
                                slotId: null,
                            };
                        }
                    });

                    Object.values(workbook.view.sheetSettings).forEach((sheetSettings:any) =>
                    {
                        if( !sheetSettings.cellSettings )
                            sheetSettings.cellSettings = {};

                        if( !sheetSettings.cellFormats )
                            sheetSettings.cellFormats = {};

                        const cellSettingsRefs = {};
                        const cellFormatsRefs = {};

                        Object.keys(sheetSettings.cellSettings).forEach((key) =>
                        {
                            const cellSettings = sheetSettings.cellSettings[key];
                            const cellLocation:string = cellSettings.id.replace(',', '_');

                            if( cellSettings.valueFormat )
                                cellFormatsRefs[cellLocation] = _valueFormatToCellFormatId(cellSettings.valueFormat);

                            const newCellSettings:any = {...cellSettings};
                            newCellSettings.id = IdUtil.newGUID();
                            delete newCellSettings.valueFormat;

                            cellSettingsRefs[cellLocation] = newCellSettings.id;
                            workbook.view.cellSettings[newCellSettings.id] = newCellSettings;
                        });

                        sheetSettings.cellSettings = cellSettingsRefs;
                        sheetSettings.cellFormats = cellFormatsRefs;
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function _valueFormatToCellFormatId(valueFormat:any):string
{
    switch( valueFormat.kind )
    {
        case 'Automatic':
            return '00000000-0000-0000-0000-de4db33f1000';
        case 'PlainText':
            return '00000000-0000-0000-0000-de4db33f1000';
        case 'MaskedText':
            return null;
        case 'Number':
        {
            if( valueFormat.digitsAfterPoint === 1 )
                return '00000000-0000-0000-0000-de4db33f2001';
            else if( valueFormat.digitsAfterPoint === 2 )
                return '00000000-0000-0000-0000-de4db33f2002';
            else if( valueFormat.digitsAfterPoint === 3 )
                return '00000000-0000-0000-0000-de4db33f2003';
            else if( valueFormat.digitsAfterPoint === 4 )
                return '00000000-0000-0000-0000-de4db33f2004';
            else if( valueFormat.digitsAfterPoint === 5 )
                return '00000000-0000-0000-0000-de4db33f2005';
            else if( valueFormat.digitsAfterPoint === 6 )
                return '00000000-0000-0000-0000-de4db33f2006';
            else if( valueFormat.digitsAfterPoint === 7 )
                return '00000000-0000-0000-0000-de4db33f2007';
            else if( valueFormat.digitsAfterPoint === 8 )
                return '00000000-0000-0000-0000-de4db33f2008';
            else if( valueFormat.digitsAfterPoint === 9 )
                return '00000000-0000-0000-0000-de4db33f2009';
            else if( valueFormat.digitsAfterPoint === 10 )
                return '00000000-0000-0000-0000-de4db33f2010';
            else
                return '00000000-0000-0000-0000-de4db33f3000';
        }
        case 'Percent':
            return '00000000-0000-0000-0000-de4db33f1200';
        case 'Accounting':
            return '00000000-0000-0000-0000-de4db33f6000';
        case 'Financial':
            return '00000000-0000-0000-0000-de4db33f3100';
        case 'Currency':
            return '00000000-0000-0000-0000-de4db33f8000';
        case 'CurrencyRounded':
            return '00000000-0000-0000-0000-de4db33f7000';
        case 'Date':
            return '00000000-0000-0000-0000-de4db33f1600';
        case 'Time':
            return '00000000-0000-0000-0000-de4db33f2200';
        case 'DateTime':
            return '00000000-0000-0000-0000-de4db33f2500';
        case 'Duration':
            return '00000000-0000-0000-0000-de4db33f3600';
        case 'Image':
        {
            return null;
        }
        default:
            throw new Error(`Unknown valueFormat kind: ${valueFormat.kind}`);
    }
}

